const config={
    base_url: "https://joblistingweb.infoxtechnologies.com",
    base_url2:"https://joblistingweb.infoxtechnologies.com"
}
export default config